module.exports = __webpack_public_path__ + "admin-thumbs/s-stacking-cards.png";